import React from 'react'
import AdmStudentCertificate from '../../components/AdminTabs/AdminStudentCertificate/AdmStudentCertificate'

const StudentCertificate = () => {
  return (
    <div>
      <AdmStudentCertificate />
    </div>
  )
}

export default StudentCertificate
